import Application from 'app/Application';

// Emulate a full ES6 environment
import 'babel-polyfill';

let app = new Application();
